'use es6';

import { buildCommentMessage } from '../../comment-message/operators/buildCommentMessage';
import { buildCommonMessage } from '../../common-message-format/operators/buildCommonMessage';
import { isCommonMessageFormat } from '../../common-message-format/operators/cmfComparators';
import { isContextUpdateMessage } from '../../context-update/operators/isContextUpdateMessage';
import ContextUpdateMessage from '../../context-update/records/ContextUpdateMessage';
import { isCrmObjectLifecycleUpdate } from '../../crm-object-lifecycle-update/operators/isCrmObjectLifecycleUpdate';
import CrmObjectLifecycleUpdate from '../../crm-object-lifecycle-update/records/CrmObjectLifecycleUpdate';
import { buildInitialMessage } from '../../initial-message/operators/buildInitialMessage';
import { isInitialMessage } from '../../initial-message/operators/isInitialMessage';
import { isMessagesUpdateMessage } from '../../message-updates/operators/isMessagesUpdateMessage';
import MessagesUpdates from '../../message-updates/records/MessagesUpdates';
import TypingIndicatorMessage from '../../typing-indicator/records/TypingIndicatorMessage';
import ReadThreadMessage from '../../read-thread-message/records/ReadThreadMessage';
import InboxUpdateMessage from '../../inbox-update-message/records/InboxUpdateMessage';
import ContactAssociationMessage from '../../contact-association-message/records/ContactAssociationMessage';
import { isTypingMessage } from '../../typing-indicator/operators/isTypingMessage';
import { isContactAssociationMessage } from '../../contact-association-message/operators/isContactAssociationMessage';
import { isInboxUpdateMessage } from '../../inbox-update-message/operators/isInboxUpdateMessage';
import { isReadThreadMessage } from '../../read-thread-message/operators/isReadThreadMessage';
import { isThreadComment } from '../../comment-message/operators/cmComparators';
import { isEmailCapturePromptMessage } from '../../email-capture-prompt/operators/isEmailCapturePromptMessage';
import { isEmailCaptureResponseMessage } from '../../email-capture-response/operators/isEmailCaptureResponseMessage';
import { isOfficeHoursMessage } from '../../office-hours-message/operators/isOfficeHoursMessage';
import { isFilteredChangeMessage } from '../../filtered-change-message/operators/isFilteredChangeMessage';
import { isThreadStatusUpdateMessage } from '../../thread-status-update/operators/isThreadStatusUpdateMessage';
import OfficeHoursMessage from '../../office-hours-message/records/OfficeHoursMessage';
import { isTypicalResponseTimeMessage } from '../../typical-response-time/operators/isTypicalResponseTimeMessage';
import EmailCapturePromptMessage from '../../email-capture-prompt/records/EmailCapturePromptMessage';
import EmailCaptureResponseMessage from '../../email-capture-response/records/EmailCaptureResponseMessage';
import AgentAvailabilityMessage from '../../agent-availability-message/records/AgentAvailabilityMessage';
import { isAgentAvailabilityMessage } from '../../agent-availability-message/operators/isAgentAvailabilityMessage';
import TypicalResponseTimeMessage from '../../typical-response-time/records/TypicalResponseTimeMessage';
import FilteredChangeMessage from '../../filtered-change-message/records/FilteredChangeMessage';
import ThreadStatusUpdateMessage from '../../thread-status-update/records/ThreadStatusUpdateMessage';
import { isAssignmentUpdateMessage } from '../../assignment-update-message/operators/isAssignmentUpdateMessage';
import AssignmentUpdateMessage from '../../assignment-update-message/records/AssignmentUpdateMessage';
import { isFeedbackSurveyMessage } from '../../feedback-survey-message/operators/isFeedbackSurveyMessage';
import { buildFeedbackSurveyMessage } from '../../feedback-survey-message/operators/buildFeedbackSurveyMessage';
import { isFeedbackSubmissionMessage } from '../../feedback-submission/operators/isFeedbackSubmissionMessage';
import { isTranscriptSubmissionMessage } from '../../transcript-submission/operators/isTranscriptSubmissionMessage';
import TranscriptSubmissionMessage from '../../transcript-submission/records/TranscriptSubmissionMessage';
import { isTicketCreationFailure } from '../../ticket-creation-failure/operators/isTicketCreationFailure';
import TicketCreationFailureMessage from '../../ticket-creation-failure/records/TicketCreationFailureMessage';
import { buildFeedbackSubmissionMessage } from '../../feedback-submission/operators/buildFeedbackSubmissionMessage';
import { isWorkflowGeneratedUserMessage } from '../../workflow-generated-user-message/operators/isWorkflowGeneratedUserMessage';
import { buildWorkflowGeneratedUserMessage } from '../../workflow-generated-user-message/operators/buildWorkflowGeneratedUserMessage';
import { isBatchSmsGeneratedUserMessage } from '../../batch-sms-generated-user-message/operators/isBatchSmsGeneratedUserMessage';
import BatchSmsGeneratedUserMessage from '../../batch-sms-generated-user-message/records/BatchSmsGeneratedUserMessage';
import { isCrmObjectWorkflowEmailSent } from '../../crm-object-workflow-email-sent/operators/isCrmObjectWorkflowEmailSent';
import CrmObjectWorkflowEmailSent from '../../crm-object-workflow-email-sent/records/CrmObjectWorkflowEmailSent';
import update from 'transmute/update';
import { isPartialMessage } from '../../partial-message/operators/isPartialMessage';
import { buildPartialMessage } from '../../partial-message/operators/buildPartialMessage';
function updateRecipients(recipients) {
  return recipients && recipients.length ? recipients.map(recipient => Object.assign({}, recipient, {
    deliveryIdentifier: recipient.singleDeliveryIdentifier
  })) : recipients;
}
export function serialize(message) {
  const messageJS = message.toJS();
  return update('recipients', updateRecipients, messageJS);
}
export function deserialize({
  json
}) {
  if (isMessagesUpdateMessage(json)) {
    return new MessagesUpdates(json);
  }
  if (isThreadComment(json)) {
    return buildCommentMessage(json);
  }
  if (isCommonMessageFormat(json)) {
    return buildCommonMessage(json);
  }
  if (isPartialMessage(json)) {
    return buildPartialMessage(json);
  }
  if (isInitialMessage(json)) {
    return buildInitialMessage(json);
  }
  if (isCrmObjectLifecycleUpdate(json)) {
    return new CrmObjectLifecycleUpdate(json);
  }
  if (isCrmObjectWorkflowEmailSent(json)) {
    return new CrmObjectWorkflowEmailSent(json);
  }
  if (isContextUpdateMessage(json)) {
    return new ContextUpdateMessage(json);
  }
  if (isTypingMessage(json)) {
    return new TypingIndicatorMessage(json);
  }
  if (isContactAssociationMessage(json)) {
    return new ContactAssociationMessage(json);
  }
  if (isEmailCaptureResponseMessage(json)) {
    return new EmailCaptureResponseMessage(json);
  }
  if (isEmailCapturePromptMessage(json)) {
    return new EmailCapturePromptMessage(json);
  }
  if (isOfficeHoursMessage(json)) {
    return new OfficeHoursMessage(json);
  }
  if (isTypicalResponseTimeMessage(json)) {
    return new TypicalResponseTimeMessage(json);
  }
  if (isFilteredChangeMessage(json)) {
    return new FilteredChangeMessage(json);
  }
  if (isThreadStatusUpdateMessage(json)) {
    return new ThreadStatusUpdateMessage(json);
  }
  if (isReadThreadMessage(json)) {
    return new ReadThreadMessage(json);
  }
  if (isInboxUpdateMessage(json)) {
    return new InboxUpdateMessage(json);
  }
  if (isAgentAvailabilityMessage(json)) {
    return new AgentAvailabilityMessage(json);
  }
  if (isAssignmentUpdateMessage(json)) {
    return new AssignmentUpdateMessage(json);
  }
  if (isFeedbackSurveyMessage(json)) {
    return buildFeedbackSurveyMessage(json);
  }
  if (isFeedbackSubmissionMessage(json)) {
    return buildFeedbackSubmissionMessage(json);
  }
  if (isTranscriptSubmissionMessage(json)) {
    return new TranscriptSubmissionMessage(json);
  }
  if (isTicketCreationFailure(json)) {
    return new TicketCreationFailureMessage(json);
  }
  if (isWorkflowGeneratedUserMessage(json)) {
    return buildWorkflowGeneratedUserMessage(json);
  }
  if (isBatchSmsGeneratedUserMessage(json)) {
    return new BatchSmsGeneratedUserMessage(json);
  }
  return json;
}